export { default as OpenShiftDetails } from './OpenShiftDetails';
